import mockResponse from '@/mocks/available-payment-methods.json'

export interface PaymentMethodsConfig {
  ideal: boolean
  revolut: boolean
  stripe: boolean
}

// Simulated endpoint response used when the real backend is unreachable or
// returns an invalid payload. Mirrors the shape of
// `/proxy-rest/get-available-payment-methods`: { success, data: {...} }.
const simulatedResponse = mockResponse as {
  success: boolean
  data: { ideal: boolean; revolut: boolean; stripe: boolean }
}

const toConfig = (data: {
  ideal?: unknown
  revolut?: unknown
  stripe?: unknown
}): PaymentMethodsConfig => ({
  ideal: !!data.ideal,
  revolut: !!data.revolut,
  stripe: !!data.stripe
})

// Fetches the payment methods availability config from the backend.
// Falls back to the simulated endpoint response on any failure so callers
// always receive a valid config instead of null.
export const getAvailablePaymentMethods = async (
  url: string
): Promise<PaymentMethodsConfig | null> => {
  try {
    const response = await fetch(`${url}/proxy-rest/get-available-payment-methods`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    const result = await response.json()

    if (!result?.success || !result?.data) {
      console.log('getAvailablePaymentMethods invalid response, using simulated response')
      return toConfig(simulatedResponse.data)
    }

    return toConfig(result.data)
  } catch (e) {
    console.log('getAvailablePaymentMethods error, using simulated response => ', e)
    return toConfig(simulatedResponse.data)
  }
}
